(() => {
  if (customElements.get('ct-shipping-bar')) return;

  const bars = new Set();
  let unsubscribe;
  let requestVersion = 0;
  let lastCart;

  const updateBars = (cart) => {
    if (!cart || !Number.isFinite(Number(cart.total_price))) return;
    lastCart = cart;
    bars.forEach((bar) => bar.update(cart));
  };

  const fetchCart = async () => {
    const version = ++requestVersion;
    try {
      const cartUrl = (typeof routes !== 'undefined' && routes.cart_url) || '/cart';
      const response = await fetch(cartUrl + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (response.ok) {
        const cart = await response.json();
        if (version === requestVersion) updateBars(cart);
      }
    } catch (error) {
      return;
    }
  };

  const onCartUpdate = (event) => {
    const cart = event && event.cartData;
    if (cart && Array.isArray(cart.items) && Number.isFinite(Number(cart.total_price))) {
      requestVersion += 1;
      updateBars(cart);
      return Promise.resolve();
    }
    return fetchCart();
  };

  const subscribeToCart = () => {
    if (unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  };

  class CTShippingBar extends HTMLElement {
    connectedCallback() {
      bars.add(this);
      this.update(lastCart || {
        total_price: Number(this.dataset.cartTotal),
        currency: this.dataset.currency
      });
      this.querySelectorAll('[data-ct-shipping-nav]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const rail = this.querySelector('[data-ct-shipping-products]');
          if (!rail) return;
          rail.scrollBy({
            left: rail.clientWidth * Number(button.dataset.ctShippingNav),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        });
      });
      subscribeToCart();
    }

    disconnectedCallback() {
      bars.delete(this);
    }

    update(cart) {
      const goal = Number(this.dataset.goal);
      const total = Math.max(0, Number(cart.total_price) || 0);
      const currency = typeof cart.currency === 'string' ? cart.currency : this.dataset.currency;
      this.hidden = currency !== 'USD' || !Number.isFinite(goal) || goal <= 0;
      if (this.hidden) return;

      const remaining = Math.max(0, goal - total);
      const progress = Math.max(0, Math.min(100, (total / goal) * 100));
      const amount = total === 0 ? goal : remaining;
      const money = '$' + (amount / 100).toFixed(2);
      const message = remaining === 0
        ? this.dataset.completeMessage
        : (total === 0 ? this.dataset.emptyMessage : this.dataset.progressMessage).replaceAll('__CT_AMOUNT__', money);

      const label = this.querySelector('[data-ct-shipping-message]');
      const track = this.querySelector('[data-ct-shipping-track]');
      const fill = this.querySelector('[data-ct-shipping-fill]');
      if (label && label.textContent.trim() !== message) label.textContent = message;
      if (track) {
        track.setAttribute('aria-valuenow', String(Math.round(progress)));
        track.setAttribute('aria-valuetext', message);
      }
      if (fill) fill.style.width = progress + '%';
      this.dataset.cartTotal = String(total);
    }
  }

  customElements.define('ct-shipping-bar', CTShippingBar);
  window.addEventListener('pageshow', fetchCart);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') fetchCart();
  });
  document.addEventListener('shopify:section:load', () => {
    subscribeToCart();
    fetchCart();
  });
})();

